<template>
    <div class="sl-main">
        <!-- SL Header -->
        <div class="sl-header">
            <div class="sl-header__title">
                <slot name="title">
                    {{ cEntity.name }}
                </slot>
            </div>
        </div>

        <!-- Side Menu -->
        <div class="sl-side-menu hidden lg:block">
            <!-- Orders -->
            <router-link
                v-slot="{ navigate, isActive }"
                :to="{ name: 'order-list', params: $route.params }"
                custom
            >
                <div
                    v-if="store.getters['account/can']('order:view')"
                    class="sl-side-menu__item"
                    :class=" { 'sl-side-menu__item--active': isActive }"
                    @click="navigate"
                >
                    {{ $t('side_menu.orders') }}
                </div>
            </router-link>

            <!-- Review Requests -->
            <router-link
                v-slot="{ navigate, isActive }"
                :to="{ name: 'entity-review-requests', params: $route.params }"
                custom
            >
                <div
                    class="sl-side-menu__item"
                    :class=" { 'sl-side-menu__item--active': isActive }"
                    @click="navigate"
                >
                    {{ $t('side_menu.review_requests') }}
                </div>
            </router-link>

            <!-- Returns -->
            <router-link
                v-slot="{ navigate, isActive }"
                :to="{ name: 'return-list', params: $route.params }"
                custom
            >
                <div
                    v-if="canAccessReturns"
                    class="sl-side-menu__item"
                    :class=" { 'sl-side-menu__item--active': isActive }"
                    @click="navigate"
                >
                    {{ $t('side_menu.returns') }}
                </div>
            </router-link>

            <div class="sl-side-menu__separator"></div>

            <!-- Invoicing -->
            <router-link
                v-slot="{ navigate, isActive }"
                :to="{ name: 'invoice-list', params: $route.params }"
                custom
            >
                <div
                    v-if="canAccessInvoicing"
                    class="sl-side-menu__item"
                    :class="{ 'sl-side-menu__item--active': isActive }"
                    @click="navigate"
                >
                    {{ $t("side_menu.invoicing") }}
                </div>
            </router-link>

            <!-- Price List -->
            <router-link
                v-slot="{ navigate, isActive }"
                :to="{ name: 'price-list', params: $route.params }"
                custom
            >
                <div
                    v-if="store.getters['account/can']('price-list:view')"
                    class="sl-side-menu__item"
                    :class=" { 'sl-side-menu__item--active': isActive }"
                    @click="navigate"
                >
                    {{ $t('side_menu.price_list') }}
                </div>
            </router-link>

            <div class="sl-side-menu__separator"></div>

            <!-- My Account -->
            <router-link
                v-slot="{ navigate, isActive }"
                :to="{ name: 'my-account', params: $route.params }"
                custom
            >
                <div
                    class="sl-side-menu__item"
                    :class="{ 'sl-side-menu__item--active': isActive }"
                    @click="navigate"
                >
                    {{ $t('side_menu.my_account') }}
                </div>
            </router-link>

            <!-- Company -->
            <router-link
                v-slot="{ navigate, isActive }"
                :to="{ name: 'contact-details', params: $route.params }"
                custom
            >
                <div
                    v-if="store.getters['account/can']('contact-details:edit')"
                    class="sl-side-menu__item"
                    :class="{ 'sl-side-menu__item--active': isActive }"
                    @click="navigate"
                >
                    {{ $t('side_menu.contact_details') }}
                </div>
            </router-link>

            <!-- User Management -->
            <router-link
                v-slot="{ navigate, isActive }"
                :to="{ name: 'user-management', params: $route.params }"
                custom
            >
                <div
                    v-if="store.getters['account/can']('user:list')"
                    class="sl-side-menu__item"
                    :class="{ 'sl-side-menu__item--active': isActive }"
                    @click="navigate"
                >
                    {{ $t('side_menu.user_management') }}
                </div>
            </router-link>
        </div>

        <!-- SL Page -->
        <slot />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const cEntity = computed(() => store.state.account.cEntity);

const canAccessReturns = computed(() =>
{
    const { type, country } = cEntity.value;
    if(['MD', 'UA'].includes(country))
    {
        return false;
    }

    return store.getters['account/can']('return:view');
});

const canAccessInvoicing = computed(() =>
{
    const { type, country } = cEntity.value;
    if(type !== 'DISTRIBUTOR' && ['MD', 'UA'].includes(country))
    {
        return false;
    }

    return store.getters['account/can']('invoice:view');
});
</script>

<style scoped>
@reference "#main.css";

.sl-side-menu
{
    @apply w-[15%];
}

.sl-side-menu__item
{
    @apply text-gray-500 text-sm py-3 px-8 cursor-pointer;
}

.sl-side-menu__item:hover
{
    @apply bg-gray-200;
}

.sl-side-menu__item--active
{
    @apply bg-primary-100 text-primary-500;
}

.sl-side-menu__item--active:hover
{
    @apply bg-primary-200 text-primary-600;
}

.sl-side-menu__separator
{
    @apply border-b border-primary-200 mb-2 pt-2 mx-6;
}
</style>
